import Modal from '../../../../../../shared/Modal'
import Button from '../../../../../../shared/Buttons/Button'
import useHttpLoader from '../../../../../../hooks/useHttpLoader'
import tasksService from '../../../../../../services/tasks/tasks.service'
import { ITask } from '../../../../../../types/tasks.types'
import useNavigationActions from '../../../../../Navigation/useNavigationActions'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import sandboxAtom from '../../../../sandbox.atom'
import navigationAtom from '../../../../../Navigation/navigation.atom'

interface IProps {
  onClose: () => void
  taskId: ITask['id']
}

const DeleteConfirmModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const { toStar } = useNavigationActions()
  const navigationState = useRecoilValue(navigationAtom)
  const setSandboxState = useSetRecoilState(sandboxAtom)

  const handleSave = () => {
    wait(tasksService.deleteTask(props.taskId), (resp) => {
      if (resp.status === 'success') {
        toStar(navigationState.star)
        setSandboxState((prev) => ({
          ...prev,
          tasks: prev.tasks.filter((t) => t.id !== props.taskId),
        }))
      }
    })
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="form">
        <h2 className="form-header" style={{ textAlign: 'center' }}>
          Подтвердите удаление интро-слайда
        </h2>
        <div className="form-footer">
          <Button onClick={props.onClose} disabled={loading}>
            Отмена
          </Button>
          <Button loading={loading} onClick={handleSave}>
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteConfirmModal
